import type { AppStore } from 'src/client/store'
import { saveFlightDateChangeProgress } from 'storage/flightDateChange'

export function watchFlightDateChange(store: AppStore) {
  // Observe both slices together so cart identity and wizard changes are saved atomically.
  let previousState = store.getState()

  return store.subscribe(() => {
    const state = store.getState()
    const involvesDateChange = state.checkout.cart.mode === 'flight-change-dates' ||
      previousState.checkout.cart.mode === 'flight-change-dates'
    const changed = state.checkout.cart !== previousState.checkout.cart ||
      state.flights.flightsDateChange !== previousState.flights.flightsDateChange ||
      state.flights.flightsDateChangeSearch !== previousState.flights.flightsDateChangeSearch
    previousState = state
    if (involvesDateChange && changed) saveFlightDateChangeProgress(state)
  })
}
